import { GEOFENCE_EVENT_KIND_TO_DICTIONARY_OPERATION } from 'constants/MeshbotConstant';

/**
 * Converts an eventKind (e.g., 'arrive') to a dictionary operation (e.g., 'added').
 *
 * @param {string} eventKind - The UI event kind.
 * @returns {string|undefined} The corresponding dictionary operation.
 */
export const convertEventKindToDictionaryOperation = (eventKind) =>
    GEOFENCE_EVENT_KIND_TO_DICTIONARY_OPERATION[eventKind];
